export const applicationName = "🌌cineverse🌌";
export const credits = {
  author: 'Elliot Garamendi',
  year: new Date().getFullYear()
};